(() => {
  const root = document.querySelector(".alarmtotal-shell");
  if (!root || root.dataset.ready === "true") return;
  root.dataset.ready = "true";

  let language = root.dataset.defaultLanguage === "en"
    ? "en"
    : root.dataset.defaultLanguage === "nl"
      ? "nl"
      : localStorage.getItem("alarmtotal-language") === "en"
        ? "en"
        : "nl";
  const recommendationState = { property: "villa", video: "yes" };

  function updateRecommendation() {
    const title = root.querySelector("[data-recommendation-title]");
    const copy = root.querySelector("[data-recommendation-copy]");
    const link = root.querySelector("[data-recommendation-link]");
    if (!title || !copy || !link) return;

    let result;
    if (recommendationState.property === "second") {
      result = {
        title: { nl: "Second Home Care", en: "Second Home Care" },
        copy: {
          nl: "Slimme beveiliging op afstand, met lekkage- en branddetectie voor periodes waarin de woning leegstaat.",
          en: "Smart remote security, with leak and fire detection while the property is unoccupied."
        },
        href: "/#pakketten"
      };
    } else if (recommendationState.property === "business") {
      result = {
        title: { nl: "Business Secure", en: "Business Secure" },
        copy: {
          nl: "Een schaalbare combinatie van alarm, toegangsbeheer en camerabewaking rond openingstijden en risicogebieden.",
          en: "A scalable mix of alarm, access management and video surveillance around opening hours and risk zones."
        },
        href: "/pages/offerte"
      };
    } else if (recommendationState.video === "yes") {
      result = {
        title: { nl: "Vision Protect", en: "Vision Protect" },
        copy: {
          nl: "Alarmbeveiliging met visuele verificatie en deurbel en camera’s in dezelfde app.",
          en: "Alarm security with visual verification, doorbell and cameras in the same app."
        },
        href: "/#cameras"
      };
    } else {
      result = {
        title: { nl: "Basiszeker", en: "Essential Secure" },
        copy: {
          nl: "Een helder startpakket voor de belangrijkste toegangen en leefruimtes, professioneel geplaatst en uitbreidbaar.",
          en: "A clear starter package for key entrances and living areas, professionally installed and expandable."
        },
        href: "/#pakketten"
      };
    }
    title.textContent = result.title[language];
    copy.textContent = result.copy[language];
    link.href = result.href;
  }

  function applyLanguage(nextLanguage) {
    language = nextLanguage;
    localStorage.setItem("alarmtotal-language", language);
    document.documentElement.lang = language;
    root.querySelectorAll("[data-nl][data-en]").forEach((element) => {
      element.textContent = element.dataset[language];
    });
    root.querySelectorAll("[data-placeholder-nl][data-placeholder-en]").forEach((element) => {
      element.placeholder = language === "nl" ? element.dataset.placeholderNl : element.dataset.placeholderEn;
    });
    root.querySelectorAll("[data-language]").forEach((button) => {
      const active = button.dataset.language === language;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", String(active));
    });
    updateRecommendation();
  }

  root.addEventListener("click", (event) => {
    const languageButton = event.target.closest("[data-language]");
    if (languageButton) applyLanguage(languageButton.dataset.language);

    const choice = event.target.closest("[data-choice]");
    if (choice) {
      const [group, value] = choice.dataset.choice.split(":");
      recommendationState[group] = value;
      root.querySelectorAll(`[data-choice^="${group}:"]`).forEach((peer) => {
        const active = peer === choice;
        peer.classList.toggle("selected", active);
        peer.setAttribute("aria-pressed", String(active));
      });
      updateRecommendation();
    }
  });

  const menuToggle = root.querySelector(".menu-toggle");
  const mobileMenu = root.querySelector(".mobile-menu");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", () => {
      const open = !mobileMenu.classList.contains("open");
      mobileMenu.classList.toggle("open", open);
      document.body.classList.toggle("menu-open", open);
      menuToggle.setAttribute("aria-expanded", String(open));
      menuToggle.setAttribute("aria-label", open ? "Menu sluiten" : "Menu openen");
    });
    mobileMenu.addEventListener("click", (event) => {
      if (!event.target.closest("a")) return;
      mobileMenu.classList.remove("open");
      document.body.classList.remove("menu-open");
      menuToggle.setAttribute("aria-expanded", "false");
    });
  }

  root.querySelectorAll("[data-current-year]").forEach((element) => {
    element.textContent = String(new Date().getFullYear());
  });

  const revealElements = root.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealElements.forEach((element) => observer.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add("visible"));
  }

  applyLanguage(language);
})();